<button
  type="button"
  i2gButton
  buttonStyle="emphasis"
  (click)="logout()"
  [disabled]="loggingOut"
  trackable
  [trackingObject]="trackingObject"
  [trackingAction]="signedOutAction"
>
  {{ 'ACTION.SIGN_OUT' | translate }}
</button>
